import $ from 'jquery';
import { initWidenVideos } from "./widen-media";

// Initialize Image Carousels with Captions so that captions switch in and out
initMediaCarouselWithCaptions(
    $(".media-shadow-carousel.with-captions, .media-modal-inner.with-captions")
);

function initMediaCarouselWithCaptions(carouselElem) {
    var carousel = $(carouselElem);

    carousel.each(function (index, value) {
        var carouselInstance = $(value);

        // Sync the carousel and captions
        carouselInstance
            .find("[data-orbit]")
            .on("slidechange.zf.orbit", function () {
                var slides = $(this).find(".orbit-slide");
                var numSlides = slides.length;
                var activeSlide = $(this).find(".orbit-slide.is-active");
                var activeNum = slides.index(activeSlide);

                // Show the appropiate figure caption
                var captions = $(this).find(".media-caption");
                captions.removeClass("is-active");
                var activeCaption = $(
                    $(this).find(".media-caption")[activeNum]
                );
                activeCaption.addClass("is-active");

                //removed to stop video and iframe
                // Pause all videos in this carousel
                $(slides)
                    .find("video")
                    .each(function (index, elem) {
                        var video = elem;

                        if ($(video).length > 0) {
                            $(video).get(0).pause();
                        }
                    });
            });
    });

    $('.orbit-next').on('click', function(){
        $('.orbit-slide').find("iframe").each(function (index, elem) {

            var iframe = elem.tagName.toLowerCase() === 'iframe';
            if(iframe == true){
                initWidenVideos(elem);
            }
        });
    });
    
    
    $('.orbit-previous').on('click', function(){
        $('.orbit-slide').find("iframe").each(function (index, elem) {
            var iframe = elem.tagName.toLowerCase() === 'iframe';
            if(iframe == true){
                initWidenVideos(elem);
            }        
        });
    });
    
    $('.media-modal-close').on('click', function(){
        $('.orbit-slide').find("iframe").each(function (index, elem) {
            var iframe = elem.tagName.toLowerCase() === 'iframe';
            if(iframe == true){
                initWidenVideos(elem);
            }        
        });
    });
    
}


window.initMediaCarouselWithCaptions = initMediaCarouselWithCaptions;